export const VERSION_CHECK_INTERVAL_MS = 60_000;

const VERSION_META_NAME = 'nava-client-version';

interface VersionResponse {
  version?: string;
}

function normalizeVersion(value: string | null | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export function getEmbeddedClientVersion(doc: Document = document): string | null {
  const versionMeta = doc.querySelector<HTMLMetaElement>(`meta[name="${VERSION_META_NAME}"]`);
  return normalizeVersion(versionMeta?.content);
}

export async function fetchRunningServiceVersion(
  fetchImpl: typeof fetch = window.fetch.bind(window)
): Promise<string | null> {
  try {
    const response = await fetchImpl('/version', {
      cache: 'no-store',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      return null;
    }

    const data = (await response.json()) as VersionResponse;
    return normalizeVersion(data.version);
  } catch {
    return null;
  }
}

export function reloadPage(locationObject: Pick<Location, 'reload'> = window.location): void {
  locationObject.reload();
}
